<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="justify-content-center">
      <CCol md="10">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
                <p class="text-muted">Bitte melden Sie sich an</p>
                <CInput
                  v-model="username"
                  placeholder="Benutzername"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="password"
                  placeholder="Password"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6">
                    <CButton color="primary" class="px-4" @click="login">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="link" class="px-0">Passwort Vergessen?</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-md-down-none"
            style="width:44%"
            body-wrapper
          >
            <h2>Neuen Benutzer Anmelden</h2>
            <p>Sie können einen neuen Benutzer über den Login des Hauptbenutzers anlegen.</p>
            
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { AUTH_REQUEST } from "../../store/actions/auth";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      token:''
    };
  },
  created() {
      var searchParams = new URLSearchParams(window.location.search);
      this.token = searchParams.get("t");
      console.log('Token: '+this.token);
      if ( this.token != '' ) {

        this.login();
      }
  },
  methods: {
    login() {
      console.log('login');

      

      const { username, password, token } = this
      this.$store.dispatch(AUTH_REQUEST, { username, password, token }).then(() => {
        this.$router.push('/order/order');
      });
    }
  }
};
</script>
